const getStatus = (rootState) => rootState.ws.history.status;

export default getStatus;
